import React, { useState, useEffect, useRef } from "react";

// === KONFIGURACJA API ===
const API_URL = "https://twoj-backend.workers.dev/api"; // <-- podmień na swój endpoint
const HUGGINGFACE_API_KEY = "hf_xxx"; // <-- podmień na swój klucz
const HUGGINGFACE_API_URL = (model) =>
  `https://api-inference.huggingface.co/models/${model}`;

// === KOMPONENT GŁÓWNY ===
export default function App() {
  // Auth
  const [user, setUser] = useState(null);
  const [authView, setAuthView] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Chat
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [chatId, setChatId] = useState(null);

  // Model AI
  const [model, setModel] = useState("gpt2"); // domyślny model
  const [isAdmin, setIsAdmin] = useState(false);
  const modelInputRef = useRef();

  // === AUTH ===
  useEffect(() => {
    // Sprawdź token w localStorage
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    if (token && user) setUser(user);
  }, []);

  // === POBIERZ MODEL Z API ===
  useEffect(() => {
    const fetchModel = async () => {
      const res = await fetch(`${API_URL}/model`);
      const data = await res.json();
      if (data?.model) setModel(data.model);
    };
    fetchModel();
  }, []);

  // === SPRAWDŹ ADMINA ===
  useEffect(() => {
    if (user && user.email === "twoj@email.com") setIsAdmin(true); // <-- podmień na swój email
    else setIsAdmin(false);
  }, [user]);

  // === POBIERZ CZATY ===
  useEffect(() => {
    if (!user) return;
    const fetchChats = async () => {
      const res = await fetch(`${API_URL}/chats?user_id=${user.id}`);
      const data = await res.json();
      setMessages(data || []);
      if (data && data.length > 0) setChatId(data[0].chat_id);
      else setChatId(Date.now().toString());
    };
    fetchChats();
  }, [user]);

  // === OBSŁUGA LOGOWANIA/REJESTRACJI ===
  const handleAuth = async (e) => {
    e.preventDefault();
    if (authView === "login") {
      const res = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (data.error) alert(data.error);
      else {
        setUser(data.user);
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
      }
    } else {
      const res = await fetch(`${API_URL}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (data.error) alert(data.error);
      else alert("Rejestracja udana! Możesz się zalogować.");
    }
  };

  // === WYLOGUJ ===
  const handleLogout = () => {
    setUser(null);
    setMessages([]);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  // === WYSYŁANIE WIADOMOŚCI ===
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    setLoading(true);

    // Zapisz wiadomość użytkownika
    await fetch(`${API_URL}/chats`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: user.id,
        message: input,
        is_user: true,
        chat_id: chatId,
      }),
    });

    setMessages((msgs) => [
      ...msgs,
      { message: input, is_user: true, chat_id: chatId },
    ]);
    setInput("");

    // Wywołaj AI
    const aiResponse = await fetch(HUGGINGFACE_API_URL(model), {
      method: "POST",
      headers: {
        Authorization: `Bearer ${HUGGINGFACE_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ inputs: input }),
    });
    const aiData = await aiResponse.json();
    const aiMsg =
      aiData?.generated_text ||
      aiData?.[0]?.generated_text ||
      aiData?.error ||
      "Brak odpowiedzi od AI";

    // Zapisz odpowiedź AI
    await fetch(`${API_URL}/chats`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: user.id,
        message: aiMsg,
        is_user: false,
        chat_id: chatId,
      }),
    });
    setMessages((msgs) => [
      ...msgs,
      { message: aiMsg, is_user: false, chat_id: chatId },
    ]);
    setLoading(false);
  };

  // === ADMIN: ZMIANA MODELU ===
  const handleModelChange = async (e) => {
    e.preventDefault();
    const newModel = modelInputRef.current.value;
    await fetch(`${API_URL}/model`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ model: newModel }),
    });
    setModel(newModel);
    alert("Model zmieniony!");
  };

  // === RENDER ===
  if (!user)
    return (
      <div style={styles.center}>
        <h2>AI Chat - Logowanie</h2>
        <form onSubmit={handleAuth} style={styles.form}>
          <input
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Hasło"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>
            {authView === "login" ? "Zaloguj" : "Zarejestruj"}
          </button>
        </form>
        <button
          onClick={() => setAuthView(authView === "login" ? "register" : "login")}
          style={styles.link}
        >
          {authView === "login"
            ? "Nie masz konta? Zarejestruj się"
            : "Masz konto? Zaloguj się"}
        </button>
      </div>
    );

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2>AI Chat</h2>
        <span>
          Zalogowany jako: <b>{user.email}</b>
        </span>
        <button onClick={handleLogout} style={styles.buttonSmall}>
          Wyloguj
        </button>
      </div>

      {isAdmin && (
        <form onSubmit={handleModelChange} style={styles.adminPanel}>
          <b>Admin: Zmień model AI</b>
          <input
            ref={modelInputRef}
            defaultValue={model}
            placeholder="np. mistral-7b-instruct"
            style={styles.input}
          />
          <button type="submit" style={styles.buttonSmall}>
            Zapisz
          </button>
        </form>
      )}

      <div style={styles.chatBox}>
        {messages
          .filter((m) => m.chat_id === chatId)
          .map((msg, i) => (
            <div
              key={i}
              style={{
                ...styles.message,
                alignSelf: msg.is_user ? "flex-end" : "flex-start",
                background: msg.is_user ? "#d1e7dd" : "#f8d7da",
              }}
            >
              {msg.message}
            </div>
          ))}
        {loading && <div style={styles.message}>AI pisze...</div>}
      </div>

      <form onSubmit={sendMessage} style={styles.formRow}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Napisz wiadomość..."
          style={styles.input}
          disabled={loading}
        />
        <button type="submit" style={styles.button} disabled={loading}>
          Wyślij
        </button>
      </form>
    </div>
  );
}

// === STYLE ===
const styles = {
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 100,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: 300,
  },
  input: {
    padding: 10,
    fontSize: 16,
    borderRadius: 5,
    border: "1px solid #ccc",
  },
  button: {
    padding: 10,
    fontSize: 16,
    borderRadius: 5,
    background: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
  buttonSmall: {
    padding: "5px 10px",
    fontSize: 14,
    borderRadius: 5,
    background: "#6c757d",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    marginLeft: 10,
  },
  link: {
    marginTop: 10,
    background: "none",
    border: "none",
    color: "#007bff",
    cursor: "pointer",
    textDecoration: "underline",
  },
  container: {
    maxWidth: 600,
    margin: "40px auto",
    padding: 20,
    border: "1px solid #eee",
    borderRadius: 10,
    background: "#fafafa",
    minHeight: 600,
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  chatBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    overflowY: "auto",
    marginBottom: 20,
    background: "#fff",
    padding: 10,
    borderRadius: 8,
    border: "1px solid #eee",
    minHeight: 300,
  },
  message: {
    maxWidth: "70%",
    padding: 10,
    borderRadius: 8,
    marginBottom: 5,
    fontSize: 16,
    wordBreak: "break-word",
  },
  formRow: {
    display: "flex",
    gap: 10,
  },
  adminPanel: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 10,
    background: "#f1f1f1",
    padding: 10,
    borderRadius: 8,
  },
};